import { useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_PRICING } from "../lib/pricing";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function usePricing() {
  const [pricing, setPricing] = useState(DEFAULT_PRICING);

  useEffect(() => {
    axios
      .get(`${API}/pricing`)
      .then((res) => setPricing(res.data))
      .catch(() => {});
  }, []);

  return pricing;
}
